import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { ClassMapConstanst, IdMapConstant, ProjConstants, RenderResponseType, Tabs } from '../../../constants/projConsts';
import KoreGenerateuuidPipe from '../../../utils/koregenerateuuid';
import {AssistSuggestions} from '../assist-suggestions/assist-suggestions';
import './assist.scss';
import { getHTML } from '../../base/domManager';
import { DATA_EVENTS, INTERNAL_EVENTS, SDK_EVENTS } from '../../../constants/events.cnst';
import { addInterruptDropdownItem } from '../atom/dialogPopups';
import { AskCustomer, AttachmentAskCustomer, Automation, ScrollDownArrowButtons, ScrollUpArrowButtons, WelcomeMessage } from '../automation/automation';
import RandomuuidPipe from '../../../utils/randomuuid';
import { addScrollButtons } from '../../../utils/scrollUtils';
import { ERROR_CODES } from '../../../constants/errorcodes';
import { ActiveOrPassive } from '../../../../../hooks/ActiveOrPassive';


export const SummaryBannerHTMLEle = (props: any) => {
    let {msgData} = props;
    const languageData = props?.hostInstance?.languagedata
    return (
        <div className="summery-conv-banner-wrapper">
            <div className="heading-text">
                <svg  width="19" height="14" viewBox="0 0 19 14" fill="none" >
                            <path d="M9.99979 5.81524V8.01866C9.56245 8.60838 8.98161 8.80996 8.40024 8.80996C7.3657 8.80996 6.64453 7.93073 6.64453 6.92499C6.64453 5.90316 7.3657 5.00732 8.40024 5.00732C8.98161 5.00732 9.56245 5.21212 9.99979 5.81524Z" fill="#111827"/>
                            <path d="M16.4016 0.310059H4.49325C4.21767 0.309988 3.94477 0.36504 3.69014 0.47207C3.43552 0.579099 3.20415 0.73601 3.00926 0.93384C2.81437 1.13167 2.65978 1.36654 2.5543 1.62505C2.44882 1.88355 2.39453 2.16062 2.39453 2.44043V9.25632C3.97002 9.26274 5.2009 10.4831 5.2009 12.0474C5.20345 12.5621 5.06557 13.0674 4.80255 13.5074H16.4016C16.9579 13.507 17.4914 13.2824 17.8848 12.883C18.2782 12.4836 18.4994 11.9419 18.4998 11.3771V2.44257C18.5001 2.1626 18.4461 1.88532 18.3408 1.62657C18.2355 1.36782 18.081 1.13269 17.8861 0.934628C17.6913 0.736565 17.4598 0.579454 17.2051 0.472284C16.9504 0.365115 16.6773 0.309988 16.4016 0.310059ZM12.2015 10.4932H10.234V9.94594C9.71132 10.2921 9.0748 10.4932 8.3113 10.4932C6.44232 10.4932 4.92796 8.91285 4.92796 6.91516C4.92796 4.88858 6.44232 3.32104 8.3113 3.32104C9.07322 3.32104 9.71132 3.5222 10.234 3.86834V3.32104H12.2015V10.4932ZM15.9679 10.4932H14.0004V3.32104H15.9706L15.9679 10.4932Z" fill="#111827"/>
                            <path d="M2.16101 10.5996C1.30956 10.5996 0.605469 11.2231 0.605469 12.0442C0.605469 12.884 1.30956 13.5075 2.16101 13.5075C3.03295 13.5075 3.73705 12.884 3.73705 12.0442C3.73705 11.2226 3.03295 10.5996 2.16101 10.5996Z" fill="#111827"/>
                </svg>
                <h1 className="aa-text-sm medium">{languageData?.CONVERSATION_SUMMARY}</h1>
            </div>
            <li>
                <span className="summary-text aa-conversaion-summary-text">{msgData}</span>
                <button className="copy-btn aa-copy-summary-text">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_9506_130502)">
                            <path d="M10.6663 10.6663V12.533C10.6663 13.2797 10.6663 13.6531 10.521 13.9383C10.3932 14.1892 10.1892 14.3932 9.93833 14.521C9.65311 14.6663 9.27974 14.6663 8.53301 14.6663H3.46634C2.7196 14.6663 2.34624 14.6663 2.06102 14.521C1.81014 14.3932 1.60616 14.1892 1.47833 13.9383C1.33301 13.6531 1.33301 13.2797 1.33301 12.533V7.46634C1.33301 6.7196 1.33301 6.34624 1.47833 6.06102C1.60616 5.81014 1.81014 5.60616 2.06102 5.47833C2.34624 5.33301 2.7196 5.33301 3.46634 5.33301H5.33301M7.46634 10.6663H12.533C13.2797 10.6663 13.6531 10.6663 13.9383 10.521C14.1892 10.3932 14.3932 10.1892 14.521 9.93833C14.6663 9.65311 14.6663 9.27974 14.6663 8.53301V3.46634C14.6663 2.7196 14.6663 2.34624 14.521 2.06102C14.3932 1.81014 14.1892 1.60616 13.9383 1.47833C13.6531 1.33301 13.2797 1.33301 12.533 1.33301H7.46634C6.7196 1.33301 6.34624 1.33301 6.06102 1.47833C5.81014 1.60616 5.60616 1.81014 5.47833 2.06102C5.33301 2.34624 5.33301 2.7196 5.33301 3.46634V8.53301C5.33301 9.27974 5.33301 9.65311 5.47833 9.93833C5.60616 10.1892 5.81014 10.3932 6.06102 10.521C6.34624 10.6663 6.7196 10.6663 7.46634 10.6663Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_9506_130502">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>
                </button>
            </li>
        </div>
    )
}

export function RenderEmptyAssistScreen(props: any) {
    const languageData = props?.hostInstance?.languagedata
    return (
        <div className="empty-listing-triggers aa-assist-empty">
            <h1 className="aa-text-sm medium">{languageData?.TRIGGER_LISTEN}</h1>
            <p className="aa-desc-xs center">{languageData?.ASSIST_EMPTY_MSG}</p>
        </div>
    )
}

export function RenderAssistHeaderLeftSections(props: any) {
    const hostInstance = props?.hostInstance
    const languageData = props?.hostInstance?.languagedata
    return (
        <>
            <div className="left-title-info assist-header-left-section">
                <div className="text-dropdown-info">
                    <h1 className="m-0">{languageData?.ASSIST}</h1>
                    <div className={`interrupt-wrapper aa-assist-interrupt-wrapper aa-hidden`}>
                        <span className="dialogs-number aa-interrupt-length">2</span>
                        <div className="aa-dropdown aa-assist-interrupt-dropdown-wrapper">
                            <button type="button" className="aa-dropdown-toggle aa-assist-interrupt-toggle" id="playbookDrp">
                                <svg className="arrow-icon aa-selected-checklist-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52876 5.52858C3.78911 5.26823 4.21122 5.26823 4.47157 5.52858L8.00016 9.05717L11.5288 5.52858C11.7891 5.26823 12.2112 5.26823 12.4716 5.52858C12.7319 5.78892 12.7319 6.21103 12.4716 6.47138L8.47157 10.4714C8.21122 10.7317 7.78911 10.7317 7.52876 10.4714L3.52876 6.47138C3.26841 6.21103 3.26841 5.78892 3.52876 5.52858Z" fill="#667085" />
                                </svg>
                            </button>
                            <div className="aa-dropdown-content playbook-dropdown-content aa-p-0 aa-assist-interrupt-dropdown-content" aria-labelledby="playbookDrp">
                                <div className="heading-text-scripts">{languageData?.INTERRUPT_DIALOG}</div>

                            </div>
                        </div>

                    </div>
                </div>
                <div className="bottom-titles aa-assist-header-dialog-wrapper aa-hidden">
                    <p className="text-truncate aa-text-xs aa-assist-header-dialog-name"></p>
                    <div className="entity-name-cstm">
                        <span className="aa-desc-xs medium">{languageData?.STEP}:</span>
                        <span className="aa-text-xs medium text-truncate aa-assist-header-entity-name"></span>
                    </div>
                </div>
            </div>
        </>
    )
}

export function RenderAssistHeaderRightSection(props: any) {

    const orderObj = {
        "smt": <div className="sentiment-sec-wrapper">
                    <button className="sentiment-btn a-flex-shrink-0 a-flex a-align-items-center a-justify-content-center aa-hidden" id="sentimentBtn"></button>
                    <div className="sentiment-chart-drp a-position-absolute aa-sentiment-popup-wrapper aa-hidden">
                        
                    </div>
                </div>,
        "rst": <button className="solid-action aa-assist-restart-btn aa-hidden" aria-label="button">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <path d="M6.56883 0.838644C6.41593 0.712508 6.1893 0.720994 6.04633 0.864052L6.02111 0.891816C5.89497 1.04471 5.90346 1.27134 6.04651 1.41431L6.77241 2.13974C4.27202 2.15882 2.25 4.19131 2.25 6.6948C2.25 9.21013 4.2912 11.25 6.80791 11.25C9.32463 11.25 11.3658 9.21013 11.3658 6.6948C11.3658 6.47992 11.1916 6.30571 10.9767 6.30571C10.7618 6.30571 10.5876 6.47992 10.5876 6.6948C10.5876 8.78024 8.89497 10.4718 6.80791 10.4718C4.72086 10.4718 3.02818 8.78024 3.02818 6.6948C3.02818 4.62198 4.70045 2.93826 6.77009 2.91797L6.04651 3.64128L6.02127 3.66902C5.89503 3.82183 5.90337 4.04848 6.04633 4.19153C6.19823 4.34353 6.44459 4.34361 6.59659 4.19171L7.9862 2.80301L8.01146 2.77525C8.13774 2.62237 8.12932 2.3956 7.9862 2.25257L6.59659 0.863872L6.56883 0.838644Z" fill="#101828" />
                    </svg>
                </button>,
        "lV": <button className="solid-action aa-assist-listview-btn" disabled aria-label="button" title={`${props?.hostInstance?.languagedata?.LIST_VIEW}`}>
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                    <path d="M8.31583 6.00268C8.31583 5.78877 8.14241 5.61536 7.9285 5.61536H4.40105L4.3658 5.61694C4.1684 5.63475 4.01372 5.80065 4.01372 6.00268C4.01372 6.2166 4.18714 6.39001 4.40105 6.39001H7.9285L7.96375 6.38843C8.16115 6.37062 8.31583 6.20471 8.31583 6.00268Z" fill="#101828" />
                    <path d="M8.31583 7.76641C8.31583 7.55249 8.14241 7.37908 7.9285 7.37908H4.40105L4.3658 7.38066C4.1684 7.39847 4.01372 7.56437 4.01372 7.76641C4.01372 7.98032 4.18714 8.15373 4.40105 8.15373H7.9285L7.96375 8.15215C8.16115 8.13434 8.31583 7.96844 8.31583 7.76641Z" fill="#101828" />
                    <path d="M7.14001 4.23896C7.14001 4.02504 6.9666 3.85163 6.75268 3.85163H4.40105L4.3658 3.85321C4.1684 3.87102 4.01372 4.03693 4.01372 4.23896C4.01372 4.45287 4.18714 4.62629 4.40105 4.62629H6.75268L6.78794 4.6247C6.98533 4.60689 7.14001 4.44099 7.14001 4.23896Z" fill="#101828" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.22524 1.5H9.10431C9.64284 1.5 10.0795 1.93612 10.0795 2.47485V9.52515C10.0795 10.0639 9.64284 10.5 9.10431 10.5H3.22524C2.68671 10.5 2.25 10.0639 2.25 9.52515V2.47485C2.25 1.93612 2.68671 1.5 3.22524 1.5ZM9.10431 2.27466H3.22524C3.11431 2.27466 3.02466 2.36419 3.02466 2.47485V9.52515C3.02466 9.63581 3.11431 9.72534 3.22524 9.72534H9.10431C9.21524 9.72534 9.30489 9.63581 9.30489 9.52515V2.47485C9.30489 2.36419 9.21524 2.27466 9.10431 2.27466Z" fill="#101828" />
                </svg>
            </button>,
        "imS": <button className="solid-action aa-assist-summary-btn a-position-relative" title={`${props?.hostInstance?.languagedata?.GENERATE_SUMMARY}`}>
                    <sup className="summary-indicator"></sup>
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <path d="M3.625 1.5C3.00684 1.5 2.5 2.00684 2.5 2.625V9.375C2.5 9.99316 3.00684 10.5 3.625 10.5H8.875C9.49316 10.5 10 9.99316 10 9.375V4.12506C10 4.0256 9.96049 3.93022 9.89017 3.85989L7.64011 1.60983C7.56978 1.53951 7.4744 1.5 7.37494 1.5H3.625ZM3.625 2.25H7V3.75C7 4.16421 7.33579 4.5 7.75 4.5H9.25V9.375C9.25 9.58594 9.08594 9.75 8.875 9.75H3.625C3.41406 9.75 3.25 9.58594 3.25 9.375V2.625C3.25 2.41406 3.41406 2.25 3.625 2.25ZM7.75 2.78027L8.71973 3.75H7.75V2.78027ZM5.125 6C4.91789 6 4.75 6.16789 4.75 6.375C4.75 6.58211 4.91789 6.75 5.125 6.75H7.375C7.58211 6.75 7.75 6.58211 7.75 6.375C7.75 6.16789 7.58211 6 7.375 6H5.125ZM5.125 7.5C4.91789 7.5 4.75 7.66789 4.75 7.875C4.75 8.08211 4.91789 8.25 5.125 8.25H6.625C6.83211 8.25 7 8.08211 7 7.875C7 7.66789 6.83211 7.5 6.625 7.5H5.125Z" fill="#202124"/>
                    </svg>
               </button>
    }
    const prefsOrderAction = props?.hostInstance?.rootService?.prefsAccessObj?.prefs?.act;
    const TitlePrefsName = props?.hostInstance?.rootService?.prefsAccessObj?.prefs?.sg?.dT?.lbl?.tmnt;

    return (
        <>
            <div className="actions-assist-header assist-header-right-section">
            {
                    prefsOrderAction.map((items:any,index:any)=>{
                        if(items['smt'] && items['smt']?.isE){
                            return orderObj['smt']
                        }
                        else if(items['rst'] && items['rst']?.isE){
                            return orderObj['rst']
                        }
                        else if(items['lV'] && items['lV']?.isE){
                            return orderObj['lV']
                        }
                        else if(items['imS'] && items['imS']?.isE){
                            return orderObj['imS']
                        }
                    })
                }

                <button className="pause-auto-send-btn a-flex a-align-items-center a-justify-content-center a-radius-4 aa-btn aa-solidbtn border-class aa-agentic-pause-auto-send-btn aa-hidden" aria-label="button">
                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none">
                        <path d="M3.90002 8.90039C3.01573 8.90039 1.5999 8.82144 1.26214 8.64935C0.965047 8.49797 0.723498 8.25642 0.572119 7.95932C0.400024 7.62157 0.400024 7.17942 0.400024 6.29513V2.92671C0.400024 2.04241 0.400024 1.60027 0.572119 1.26251C0.723498 0.965413 0.965047 0.723865 1.26214 0.572486C1.5999 0.400391 2.04205 0.400391 2.92634 0.400391H8.40002C9.28432 0.400391 9.72647 0.400391 10.0642 0.572486C10.3613 0.723865 10.6029 0.965413 10.7542 1.26251M0.400024 1.97934L3.32108 3.87407" stroke="#079455" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                        <g clip-path="url(#clip0_5891_27936)">
                        <path d="M8.15004 3.77474V6.14974L9.73338 6.94141M12.1084 6.14974C12.1084 8.33587 10.3362 10.1081 8.15004 10.1081C5.96392 10.1081 4.19171 8.33587 4.19171 6.14974C4.19171 3.96361 5.96392 2.19141 8.15004 2.19141C10.3362 2.19141 12.1084 3.96361 12.1084 6.14974Z" stroke="#079455" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_5891_27936">
                        <rect width="9.5" height="9.5" fill="white" transform="translate(3.40002 1.40039)"/>
                        </clipPath>
                        </defs>
                    </svg>
                </button>
                <button className="pause-agentic-btn aa-agentic-pause-btn aa-btn aa-solidbtn border-class aa-hidden" aria-label="button">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="aa-pause-state">
                    <path d="M3.87402 10.1133C3.87382 10.3821 3.65561 10.5996 3.38672 10.5996C3.13281 10.5994 2.9248 10.4054 2.90234 10.1572L2.90137 10.1523L2.90039 10.1172L2.89941 10.1133H2.90039V1.88672C2.90059 1.618 3.118 1.40059 3.38672 1.40039C3.6408 1.40039 3.84961 1.59448 3.87207 1.84277L3.87305 1.84766H3.87207L3.87402 1.88281V10.1133ZM9.2207 10.1133C9.2205 10.3821 9.00229 10.5996 8.7334 10.5996C8.47953 10.5994 8.27148 10.4054 8.24902 10.1572L8.24805 10.1523L8.24707 10.1172V1.88672C8.24727 1.61803 8.46473 1.40065 8.7334 1.40039C8.98748 1.40039 9.19628 1.59449 9.21875 1.84277L9.21973 1.84766L9.2207 1.88281V10.1133Z" fill="#202124" stroke="#202124" stroke-width="0.2"/>
                    </svg>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="aa-play-state aa-hidden">
                    <path d="M2.5 2.49476C2.5 2.00917 2.5 1.76638 2.60125 1.63255C2.68945 1.51595 2.82426 1.4438 2.9702 1.43509C3.13772 1.42509 3.33973 1.55976 3.74376 1.82912L9.00154 5.3343C9.33538 5.55686 9.5023 5.66815 9.56047 5.80841C9.61133 5.93103 9.61133 6.06885 9.56047 6.19148C9.5023 6.33174 9.33538 6.44302 9.00154 6.66558L3.74376 10.1708C3.33973 10.4401 3.13772 10.5748 2.9702 10.5648C2.82426 10.5561 2.68945 10.4839 2.60125 10.3673C2.5 10.2335 2.5 9.99071 2.5 9.50513V2.49476Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <button className="solid-action stop-assist aa-assist-terminate-btn" disabled aria-label="button" title={TitlePrefsName ? TitlePrefsName : props?.hostInstance?.languagedata?.TERMINATE}>
                    <span></span>
                </button>
            </div>
        </>
    )
}


export function Assist({ hostInstance }: any) {
    
    const rootServiceInstance = hostInstance.rootService;
    const localStorageServiceInstance = hostInstance.localStorageService;
    const [assistResponseArray, setAssistResponseArray] = useState<any>([]);
    const [ambiguityToken, setAmbiguityToken] = useState<any>({});
    const [welcomeMsgResponse, setWelcomeMsgResponse] = useState<any>({});
    const [interruptDialog, setInterruptDialog] = useState({});
    const [interruptRun, setInterruptRun] = useState(false);
    const [showErrorPrompt, setShowErrorPrompt] = useState(false);
    const [isCoPilotEnabled, setIsCoPilotEnabled] = useState(false);

    const classConstants : any = ClassMapConstanst;   
    let currentEntityNode : any = null;
    let templateClick = false;

    useEffect(() => {

        initializeUI();
        registerEventListeners();
        fetchAssistData();
    
        return () => {
            unregisterEventListeners();
        };
    }, []);
    
    const initializeUI = () => {
        addEmptyScreen();
        addAssistHeader();
        addAssistScrollButtons();
    };
    
    const registerEventListeners = () => {
        hostInstance.on(DATA_EVENTS.AGENT_AI_RESPONSE, handleAgentAssistResponse);
        hostInstance.on(DATA_EVENTS.END_OF_TASK_RESPONSE, handleEndOfTaskResponse);
        hostInstance.on(DATA_EVENTS.AGENT_ASSIST_USER_MESSAGE, handleUserMessageResponse);
        hostInstance.on('CONVERSATION_SUMMARY_IN_ASSIST', showConversationSummaryResponse);
        hostInstance.on(DATA_EVENTS.PRO_ACTIVE_CHANGE, handleProactiveModeChange);
        hostInstance.on(INTERNAL_EVENTS.TEMPLATE_CLICK, handleTemplateClickEvents);
        // window.addEventListener('resize', handleWindowResize);
        listenInterruptEvents();
        listenTerminateEvents();
        listenRunClickEvents();
    };
    
    const unregisterEventListeners = () => {
        hostInstance.off(DATA_EVENTS.AGENT_AI_RESPONSE, handleAgentAssistResponse);
        hostInstance.off(DATA_EVENTS.END_OF_TASK_RESPONSE, handleEndOfTaskResponse);
        hostInstance.off(DATA_EVENTS.AGENT_ASSIST_USER_MESSAGE, handleUserMessageResponse);
        hostInstance.off('CONVERSATION_SUMMARY_IN_ASSIST', showConversationSummaryResponse);
        hostInstance.off(DATA_EVENTS.PRO_ACTIVE_CHANGE, handleProactiveModeChange);
        hostInstance.off(INTERNAL_EVENTS.TEMPLATE_CLICK, handleTemplateClickEvents);
        // window.removeEventListener('resize', handleWindowResize);
    };
    
    const handleAgentAssistResponse = (assistResponse: any) => {
        if (assistResponse && Object.keys(assistResponse).length > 0) {
            rootServiceInstance.makeOverrideEvent(hostInstance, false);
            updateAgentAssistResponse(assistResponse);
        }
    };
    
    const handleEndOfTaskResponse = (endoftaskresponse: any) => {
        if (endoftaskresponse.intType != 'myBot' && endoftaskresponse.intType != 'custom') {
            dialogTerminatedOrInterrupted(); 
            interruptDialogCheck();  
        }
    };

    useEffect(() => {
        rootServiceInstance.handleAssistScroll(hostInstance);
        if (assistResponseArray?.length > 0) {
            hideEmptyScreen();
        }
    }, [assistResponseArray]);

    useEffect(() => {
        handleDialogInterrupt(interruptDialog);
    }, [interruptDialog]);

    useEffect(() => {
        handleWelcomeMessage();
    }, [welcomeMsgResponse]);

    

    const handleDialogInterrupt = (dialog : any) => {
        if (dialog && Object.keys(dialog).length > 0) {
            const footerTag = hostInstance.chatEle.querySelector(classConstants.FOOTER);
            hostInstance.openAssistTab(footerTag, true);
            let currentDialogName = assistResponseArray[assistResponseArray?.length - 1]?.dialogName;
            rootServiceInstance.toggleInterruptPopup(hostInstance, true, currentDialogName);
        }
    };

    const handleWelcomeMessage = () => {
        if (welcomeMsgResponse && Object.keys(welcomeMsgResponse).length > 0) {
            const welcomeHtml = getHTML(WelcomeMessage, { welcomeMsg: welcomeMsgResponse?.buttons }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, welcomeHtml, {
                event: SDK_EVENTS.WELCOME_MSG_TEMPLATE,
                data : welcomeMsgResponse
            });

            const assistSection = hostInstance?.chatEle?.querySelector(classConstants.ASSIST_SECTION);
            if(rootServiceInstance.agenticStart){
                const agenticCopilotNodeWrapper = assistSection.querySelectorAll(`.aa-agentic-copilot-node-wrapper`);
                const agenticEmptyScreen = assistSection.querySelector(`.aa-assist-empty-agentic`);
                if(agenticCopilotNodeWrapper.length > 0){
                    agenticCopilotNodeWrapper[0].before(welcomeHtml);
                }else if(agenticEmptyScreen){
                    agenticEmptyScreen.before(welcomeHtml);
                }else{
                    assistSection.prepend(welcomeHtml);
                }
            }else{
                hostInstance?.chatEle?.querySelector(classConstants.ASSIST_SECTION)?.append(welcomeHtml);
            }
            hideEmptyScreen();
            rootServiceInstance.handleWelcomeMsgResponse(welcomeMsgResponse, welcomeHtml, hostInstance);
        }
    };

    const listenRunClickEvents = () => {
        const handleRunClickEvent = (runEventObj : any) => {
            if (runEventObj && !runEventObj.agentRunButton && !runEventObj.customTabInterrupt) {
                const footerTag = hostInstance.chatEle.querySelector(classConstants.FOOTER);
                hostInstance.openAssistTab(footerTag, true);
                if (!rootServiceInstance.isAutomationOnGoing) {
                    if (runEventObj.from === ProjConstants.INTERRUPT) {
                        removeDialogFromInterruptList(runEventObj);
                    }
                    // it should be just before updating in assist response
                    runEventObj.positionId = RandomuuidPipe('positionId');
                    addAutomationNodeInAssistResponse(runEventObj);
                    rootServiceInstance.runDialogForAssistOrMybot(hostInstance, runEventObj);
                } else {
                    hostInstance.emit(INTERNAL_EVENTS.INTERRUPT_POPUP_EVENT, runEventObj);
                }
            }
        };
    
        const removeDialogFromInterruptList = (runEventObj : any) => {            
            const interruptDropdownContainer = hostInstance?.chatEle?.querySelector(ClassMapConstanst.ASSIST_INTERRUPT_DROPDOWN_CONTENT);
            const interruptDialogItem = interruptDropdownContainer.querySelector(`${ClassMapConstanst.INTERRUPT_DIALOG}${runEventObj.positionId}`);
    
            if (interruptDialogItem) {
                interruptDialogItem.remove();
            }
            rootServiceInstance.interruptDialogList.splice(runEventObj.index, 1);
            rootServiceInstance.toggleInterruptDropdown(Tabs.ASSIST, hostInstance);
        };
    
        hostInstance.on(INTERNAL_EVENTS.RUN_CLICK_EVENT, handleRunClickEvent);
    };
    
    const listenTerminateEvents = () => {
        const handleTerminateEvent = () => {
            const lastAutomation : any = getLastAutomation();
            if (rootServiceInstance.isAutomationOnGoing) {
                rootServiceInstance.sendRunClickEvent(hostInstance, { intentName: ProjConstants.DISCARD_ALL, sourceMsgId: lastAutomation.sourceMsgId, positionId: lastAutomation.positionId });
            }
            rootServiceInstance.toggleTerminatePopup(hostInstance, false);
        };
    
        const handleTerminateOverrideEvent = (data : any) => {
            rootServiceInstance.manualAssistOverrideMode = true;
            hostInstance.handleOverrideMode(true, null);
            if(!data?.entityExtraction){
                rootServiceInstance.toggleTerminatePopup(hostInstance, false);
            }
            showOrHideLastNodeActionButtons(false);
        };

        hostInstance.on(INTERNAL_EVENTS.TERMINATE_EVENT, (data : any) => {            
            if (data?.activeTab === Tabs.ASSIST) {
                handleTerminateEvent();
            }
        });

        hostInstance.on(INTERNAL_EVENTS.TERMINATE_OVERRIDE_EVENT, (data : any) => {            
            if (data?.activeTab === Tabs.ASSIST) {
                handleTerminateOverrideEvent(data);
            }
        });
    };

    const showOrHideLastNodeActionButtons = (showInputIcons : boolean, disabled = false) => {
        const lastAutomation : any = getLastAutomation();        
        if(lastAutomation?.type === RenderResponseType.AUTOMATION || lastAutomation?.type === RenderResponseType.SMALLTALK){
            const lastObj = lastAutomation?.type === RenderResponseType.AUTOMATION ? lastAutomation?.automationNodes[lastAutomation.automationNodes?.length - 1] : lastAutomation;
            
            if(lastObj?.data?.isPrompt && lastObj.nodeType === RenderResponseType.ENTITY_NODE){
                const askCustNode = hostInstance?.chatEle?.querySelector(`${classConstants.ASK_CUST_NODE}${lastObj.uuid}`);        
                const inputEle = askCustNode?.querySelector(`${classConstants.ENTITY_INPUT}`);
                if(!showInputIcons){
                    if(disabled){
                        inputEle.readOnly = true;
                        inputEle.placeholder = '';
                        inputEle.blur();
                    }else{
                        inputEle.readOnly = false;
                        inputEle.placeholder = '';
                        inputEle.focus();
                    }
                    rootServiceInstance.handleEntityInput(lastObj, hostInstance, true);
                }else{                    
                    showLastNodeActionButtons(lastAutomation);
                    rootServiceInstance.showEntityNodeInputButtons(askCustNode);
                }

                if(lastObj?.data?.entityType === 'attachment'){
                    if(!showInputIcons){
                        rootServiceInstance.toggleAttachmentDiv(lastObj, askCustNode, inputEle, true);
                    }else{
                        rootServiceInstance.toggleAttachmentDiv(lastObj, askCustNode, inputEle, false);
                        rootServiceInstance.addorRemoveAttachemntFileError(lastObj, hostInstance, true);
                    }
                }
            }
        }
    };

    const showLastNodeActionButtons = (lastAutomation : any) => {
        if(lastAutomation?.type === RenderResponseType.AUTOMATION || lastAutomation.type === RenderResponseType.SMALLTALK){
            const lastObj = (lastAutomation?.type === RenderResponseType.AUTOMATION) ? lastAutomation?.automationNodes[lastAutomation.automationNodes?.length - 1] : lastAutomation;
            if(lastObj?.data?.isPrompt && lastObj.nodeType === RenderResponseType.ENTITY_NODE){                
                const askCustNode = hostInstance?.chatEle?.querySelector(`${classConstants.ASK_CUST_NODE}${lastObj.uuid}`);        
                const inputEle = askCustNode?.querySelector(`${classConstants.ENTITY_INPUT}`);
                inputEle.readOnly = true;
                inputEle.placeholder = `${hostInstance?.languagedata?.WAITING}`;
            }
        }
    }
    
    const listenInterruptEvents = () => {
        const openInterruptPopup = (runEventObj : any) => {   
            if(!runEventObj.agentRunButton){
                setInterruptDialog({ ...runEventObj });
            }         
        };
    
        const handleInterruptRun = (data : any) => {
            if (data?.activeTab === Tabs.ASSIST) {
                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
                const lastAutomation : any = getLastAutomation();
        
                if (rootServiceInstance.isAutomationOnGoing) {
                    setInterruptRun(true);
                    rootServiceInstance.sendRunClickEvent(hostInstance, { intentName: ProjConstants.DISCARD_ALL, sourceMsgId: lastAutomation.sourceMsgId, positionId: lastAutomation.positionId });
                }
            }
        };
    
        const handleInterruptRunLater = (data : any) => {            
            if (data?.activeTab === Tabs.ASSIST) {
                let interruptedDialog: any = {};
                setInterruptDialog((dialog: any) => {                
                    dialog.from = ProjConstants.INTERRUPT;
                    interruptedDialog = dialog;
                    return dialog;
                });
                
                const interruptDropdownContainer = hostInstance?.chatEle?.querySelector(ClassMapConstanst.ASSIST_INTERRUPT_DROPDOWN_CONTENT);
                
                if (!isDialogInInterruptList(interruptedDialog)) {
                    rootServiceInstance.interruptDialogList.push(interruptedDialog);                
                    showInterruptDropdown(interruptDropdownContainer, interruptedDialog);
                    addRunClickEventListener(interruptedDialog, interruptDropdownContainer);
                }
        
                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
            }
        };
    
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_POPUP_EVENT, openInterruptPopup);
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_ACCEPT_EVENT, handleInterruptRun);
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_RUNLATER_EVENT, handleInterruptRunLater);
    };
    
    const getLastAutomation = () => {
        let lastAutomation : any;
        setAssistResponseArray((prevResponse : any) => {
            lastAutomation = prevResponse[prevResponse?.length - 1];
            return prevResponse;
        });
        return lastAutomation
    };
    
    const isDialogInInterruptList = (dialog : any) => {        
        return rootServiceInstance.interruptDialogList.findIndex((d : any) => d.intentName === dialog.intentName) !== -1;
    };
    
    const addRunClickEventListener = (interruptedDialog : any, container : any) => {
        hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.INTERRUPT_DIALOG}${interruptedDialog?.positionId}`, 'click', () => {  
            hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, interruptedDialog);
            rootServiceInstance.toggleInterruptPopup(hostInstance, false);
        }, container);
    };
    
    const showInterruptDropdown = (interruptDropdownContainer : any, interruptedDialog : any) => {        
        const interruptDropdownItem = getHTML(addInterruptDropdownItem, { hostInstance, dialog: interruptedDialog }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, interruptDropdownItem, {
            event: SDK_EVENTS.INTERRUPT_DROPDOWN_ITEM_TEMPLATE,
            data : interruptedDialog
        });
        interruptDropdownContainer.append(interruptDropdownItem);
        rootServiceInstance.toggleInterruptDropdown(Tabs.ASSIST, hostInstance);
    };
    
    const dialogTerminatedOrInterrupted = (feedbackObj : any = {}) => {
        const lastAutomation = getLastAutomation();
        rootServiceInstance.updateLocalStorageForAssist(hostInstance, lastAutomation, false);
        const dialogEndNode = rootServiceInstance.prepareDialogEndNodeResponse(lastAutomation.dialogId);
        const feedbackNode = rootServiceInstance.prepareFeedbackDataForDialog(lastAutomation, feedbackObj);
        rootServiceInstance.closeListView(hostInstance);
        showOrHideLastNodeActionButtons(false, true);
        addNodeInAutomation(dialogEndNode);
        addNodeInAutomation(feedbackNode);    
    };
    
    const interruptDialogCheck = () => {
        setInterruptRun((flag) => {
            if (flag) {
                setInterruptDialog((dialog) => {
                    hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, dialog);
                    return dialog;
                });
                return false; // Reset interrupt run state
            }
            return flag;
        });
    };
    

    const addEmptyScreen = () => {
        let emptyScreenHtml = getHTML(RenderEmptyAssistScreen, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, emptyScreenHtml, {
            event: SDK_EVENTS.ASSIST_EMPTY_TEMPLATE
        });
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_SECTION}`).append(emptyScreenHtml);
    }

    const hideEmptyScreen = () => {
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_EMPTY_SCREEN}`)?.classList?.add(classConstants.HIDE_ELEMENT);
    }

    const addAssistHeader = () => {
        let assistLeftSectionHtml = getHTML(RenderAssistHeaderLeftSections, {}, hostInstance);
        let assistRightSectionHtml = getHTML(RenderAssistHeaderRightSection, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, assistLeftSectionHtml, {
            event: SDK_EVENTS.ASSIST_HEADER_LEFT_SECTION
        });
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, assistRightSectionHtml, {
            event: SDK_EVENTS.ASSIT_HEADER_RIGHT_SECTION
        });
        let headerSection = hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_HEADER_SECTIONS}`);
        if(assistLeftSectionHtml && assistRightSectionHtml && headerSection){
            headerSection.append(assistLeftSectionHtml);
            headerSection.append(assistRightSectionHtml);
            handleHeaderClickEvents(assistLeftSectionHtml, assistRightSectionHtml);
        }
    }

    const addAssistScrollButtons = () => {
        addScrollButtons(
            hostInstance,
            classConstants,
            rootServiceInstance,
            {
                containerClass: classConstants.ASSIST_SECTION,
                headerClass: classConstants.ASSIST_HEADER_SECTIONS,
                upArrowClass: classConstants.ASSIST_UP_ARROW,
                downArrowClass: classConstants.ASSIST_DOWN_ARROW,
                tabType: Tabs.ASSIST
            }
        );
    };
    

    const handleHeaderClickEvents = (assistLeftSectionHtml : any, assistRightSectionHtml : any) => {
        hostInstance?.eventManager?.addEventListener?.(`${classConstants.ASSIST_TERMINATE_BUTTON}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.TERMIANTE_POPUP}`).classList?.remove(classConstants.HIDE_ELEMENT);
            let terminateOverrideBtn =  hostInstance?.chatEle?.querySelector?.(`${classConstants.TERMINATE_OVERRIDE_BTN}`);
            if(rootServiceInstance.proactiveMode){
                terminateOverrideBtn?.classList?.remove(classConstants.HIDE_ELEMENT);
            }else{
                terminateOverrideBtn?.classList?.add(classConstants.HIDE_ELEMENT);
            }
        }, assistRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${classConstants.ASSIST_LISTVIEW_BUTTON}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.LIST_VIEW_POPUP}`).classList?.remove(classConstants.HIDE_ELEMENT);
            formatListViewEntityList();

        },assistRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${classConstants.ASSIST_RESTART_BUTTON}`, 'click', (e : any) => {
        },assistRightSectionHtml);

        hostInstance?.eventManager?.addEventListener(`#${IdMapConstant.SENTIMENT_BTN}`, 'click', (event: any) => {
            event.stopPropagation();
            console.log("sentimentBtn clicked",hostInstance?.chatEle?.querySelector?.(`${classConstants.SENTIMENT_POPUP_WRAPPER}`));
            hostInstance?.chatEle?.querySelector?.(`${classConstants.SENTIMENT_POPUP_WRAPPER}`)?.classList?.toggle(classConstants.HIDE_ELEMENT);
        }, assistRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${classConstants.ASSIST_SUMMARY_BTN}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.ASSIST_SUMMARY_BTN}`)?.setAttribute('disabled', 'true');
            generateInterimSummary();
        },assistRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${classConstants.ASSIST_INTERRUPT_TOGGLE_BTN}`, 'click', (e : any) => {
            assistLeftSectionHtml?.querySelector(`${classConstants.ASSIST_INTERRUPT_DROPDOWN_WRAPPER}`)?.classList.toggle('show');
        },assistLeftSectionHtml);
    }

    const updateAgentAssistResponse = (data: any) => {
        processDataBeforeFormatting(data);
        const responseType = rootServiceInstance.getTypeOfResponse(data);
        formatResponseBasedOnType(data, responseType);
    };

    const processDataBeforeFormatting = (data: any) => {
        rootServiceInstance.removeLoaderForAutomation(hostInstance, document.querySelector(`${classConstants.ASSIST_SECTION}`) as HTMLElement);
        if (data) {
            data.expectedFormat = data.entityType;
        }

        handleOngoingAutomation(data);

        if (shouldInitiateDialog(data)) {
            const initDialog = rootServiceInstance.prepareDialogObjForInitDialog(data);
            addAutomationNodeInAssistResponse(initDialog);
            rootServiceInstance.runDialogForAssistOrMybot(hostInstance, initDialog, true);
        }
    };

    const handleOngoingAutomation = (data: any) => {
        if (rootServiceInstance.isAutomationOnGoing && (data.suggestions?.dialogs?.length > 0 || data?.exitEvent)) {
            showOrHideLastNodeActionButtons(false, true);
            dialogTerminatedOrInterrupted();
        }
    };

    const shouldInitiateDialog = (data: any) => {
        return !rootServiceInstance.isAutomationOnGoing && data.intentName && (data?.onConnectTask || data?.exitEvent) && (!data.suggestions && data.buttons?.length > 0);
    };

    const formatResponseBasedOnType = (data: any, responseType: string) => {
        if(responseType){
            const responseId = KoreGenerateuuidPipe();
    
            let result: any = hostInstance.templateRenderService.getResponseUsingTemplate(data);
            // let msgStringify = JSON.stringify(result);
            // data.temp = encodeURI(msgStringify);  
            data.templateResult = result;
            data.templateClick = templateClick;
    
            switch (responseType) {
                case RenderResponseType.SUGGESTIONS:
                    if (!rootServiceInstance.isAutomationOnGoing) {
                        handleSuggestionsResponse(data, responseId);
                    }
                    break;
    
                case RenderResponseType.AUTOMATION_NODE:
                    handleAutomationNodeResponse(data, responseId);
                    break;
    
                case RenderResponseType.SMALLTALK:
                    handleSmallTalkResponse(data, responseId);
                    break;
    
                case RenderResponseType.WELCOME_MSG:
                    handleWelcomeMsgResponse(data, responseId);
                    break;
    
                default:
                    break;
            }
        }
    };

    const handleSuggestionsResponse = (data: any, responseId: string) => {
        if (!data.uiunqref) {
            let suggestionIndex = 0;
            setAssistResponseArray((prevResponse: any) => {
                suggestionIndex = prevResponse?.length || 0;
                return prevResponse;
            });
            const assistDataObj = rootServiceInstance.prepareSuggestionResponse(data, responseId, suggestionIndex);
            if(Object.keys(assistDataObj?.searchResponse)?.length > 0){ 
                setAssistResponseArray((prevResponse: any) => [...prevResponse, assistDataObj]);
                addSuggestionTemplate(assistDataObj, suggestionIndex);
            }
            if (rootServiceInstance.connectionDetails.channel === ProjConstants.VOICE && data.suggestions) {
                hostInstance.emit(DATA_EVENTS.CALL_CONVERSATION_SUGGESTIONS, {data : data, uuid : responseId, suggestionIndex})
            }
        } else {
            updateSuggestionResponse(data);
        }
    };

    const handleAutomationNodeResponse = (data: any, responseId: string) => {
        if (data?.buttons?.[0]?.value) {
            let automationNodeObj = rootServiceInstance.prepareAutomationNodeResponse(data, responseId);
            automationNodeObj = data.isPrompt
                ? rootServiceInstance.prepareEntityNodeResponse(data, automationNodeObj, hostInstance)
                : rootServiceInstance.prepareMsgNodeResponse(data, automationNodeObj, hostInstance);
            currentEntityNode = data.isPrompt ? automationNodeObj : null;
            addNodeInAutomation(automationNodeObj);
        }
    };

    const handleSmallTalkResponse = (data: any, responseId: string) => {
        if (data?.buttons?.[0]?.value) {
            let assistDataObj = rootServiceInstance.prepareSmallTalkResponse(data, responseId);
            assistDataObj = data.isPrompt
                ? rootServiceInstance.prepareEntityNodeResponse(data, assistDataObj, hostInstance)
                : rootServiceInstance.prepareMsgNodeResponse(data, assistDataObj, hostInstance);
            currentEntityNode = data.isPrompt ? assistDataObj : null;
            rootServiceInstance.addSmallTalkTemplate(assistDataObj, ProjConstants.ASSIST, hostInstance);
            setAssistResponseArray((prevResponse: any) => [...prevResponse, assistDataObj]);
        }
    };

    const handleWelcomeMsgResponse = (data: any, responseId: string) => {
        const assistDataObj = rootServiceInstance.prepareWelcomeMsgResponse(data, responseId);
        setWelcomeMsgResponse(data);
        setAssistResponseArray((prevResponse: any) => [...prevResponse, assistDataObj]);
    };

    const updateSuggestionResponse = (data: any) => {
        const ambiguityTokenExt = JSON.parse(atob(data.uiunqref));
        setAssistResponseArray((prevResponse: any) => {
            const isFaqAnswer = isAmbiguousFAQ(ambiguityTokenExt, data);
            if (isFaqAnswer) {
                return handleFAQAmbiguity(prevResponse, data, ambiguityTokenExt);
            }
            return prevResponse;
        });
        setAmbiguityToken(ambiguityTokenExt);
    };
    
    const isAmbiguousFAQ = (ambiguityTokenExt: any, data: any): boolean => {
        return ambiguityTokenExt && ambiguityTokenExt.question === data.suggestions?.faqs[0]?.question;
    };
    
    const handleFAQAmbiguity = (prevResponse: any, data: any, ambiguityTokenExt: any) => {
        const assistResArray = rootServiceInstance.updateSearchResponse(prevResponse, data, ambiguityTokenExt);
        const faqId = `${IdMapConstant.ASSIST_FAQ_SUGGESTION}${ambiguityTokenExt.assistSuggestion}`;
        rootServiceInstance.handleFaqAmbiguityDescElement(faqId, ambiguityTokenExt, prevResponse[ambiguityTokenExt.assistSuggestion]?.searchResponse?.faqs, hostInstance);
        return assistResArray;
    };
    
    const addSuggestionTemplate = (suggestionObj: any, suggestionIndex: number) => {
        const suggestionHtml : any = getHTML(AssistSuggestions, { suggestions: suggestionObj, hostInstance, suggestionIndex }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, suggestionHtml, {
            event: SDK_EVENTS.ASSIST_SUGGESTIONS_TEMPLATE,
            data : {suggestionObj, suggestionIndex}
        });
        appendToAssistSection(suggestionHtml);
    };
    
    const addAutomationTemplate = (automation: any) => {
        const automationHtml : any = getHTML(Automation, { dialog: automation, hostInstance }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, automationHtml, {
            event: SDK_EVENTS.DIALOG_WRAPPER,
            data : automation
        });
        appendToAssistSection(automationHtml);
        rootServiceInstance.addDialogTemplate(automation.automationNodes[0], automation, ProjConstants.ASSIST, hostInstance);
    };
    
    const appendToAssistSection = (html: HTMLElement) => {
        const assistSection = hostInstance?.chatEle?.querySelector(classConstants.ASSIST_SECTION);        
        if (assistSection) {
            const clonedHtml = html.cloneNode(true) as HTMLElement; // Clone the HTML element
            if(rootServiceInstance.agenticStart){
                const agenticCopilotNodeWrapper = assistSection.querySelectorAll(`.aa-agentic-copilot-node-wrapper`);
                const agenticEmptyScreen = assistSection.querySelector(`.aa-assist-empty-agentic`);
                if(agenticCopilotNodeWrapper.length > 0){
                    agenticCopilotNodeWrapper[0].before(clonedHtml);
                }else if(agenticEmptyScreen){
                    agenticEmptyScreen.before(clonedHtml);
                }else{
                    assistSection.prepend(clonedHtml);
                }
            }else{
                assistSection.append(clonedHtml); // Append the cloned element
            }
        }
    };

    const addAutomationNodeInAssistResponse = (runEventObj: any) => {
        const responseId = KoreGenerateuuidPipe();
        const automationRenderResponse = rootServiceInstance.prepareAutomationReponse(runEventObj, responseId, ProjConstants.ASSIST);
        setAssistResponseArray((prevResponse: any) => [...prevResponse, automationRenderResponse]);
        addAutomationTemplate(automationRenderResponse);
    };
    
    const addNodeInAutomation = (automationNodeObj: any) => {
        setAssistResponseArray((prevResponse: any) => {
            const updatedArray = [...prevResponse];
            const lastObj = updatedArray[updatedArray.length - 1];
            if (lastObj?.type === RenderResponseType.AUTOMATION) {
                rootServiceInstance.handleErrorPrompts(lastObj, automationNodeObj, hostInstance);
                updateAutomationNode(lastObj, automationNodeObj);
                addNodeInListView(automationNodeObj, lastObj);
            }
            return updatedArray;
        });
    };
    
    const updateAutomationNode = (lastObj: any, automationNodeObj: any) => {
        automationNodeObj.dialogId = lastObj.dialogId;
        lastObj.automationNodes.push(automationNodeObj);
        const entityDisplayName = automationNodeObj?.data?.entityDisplayName || automationNodeObj?.data?.entityName;
        if (entityDisplayName) {
            updateAssistHeaderEntityName(entityDisplayName);
        }
        rootServiceInstance.addDialogTemplate(automationNodeObj, lastObj, ProjConstants.ASSIST, hostInstance);
    };

    const addNodeInListView = (automationNode : any, automation : any) => {
        if(!hostInstance?.chatEle?.querySelector(`${classConstants.LIST_VIEW_POPUP}`)?.classList?.contains(classConstants.HIDE_ELEMENT)){
            renderEntityInListView (automationNode, automation);
        }
    }
    
    const updateAssistHeaderEntityName = (entityDisplayName: string) => {
        const assistHeaderEntityName = hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_HEADER_ENTITY_NAME}`);
        assistHeaderEntityName.innerText = entityDisplayName;
    };

    const handleProactiveModeChange = (checked : boolean) => {
        showOrHideLastNodeActionButtons(checked);
    }
    
    const handleTemplateClickEvents = (obj : any) => {
        if(obj.tab === Tabs.ASSIST){
            let message = obj.messageText;
            let lastAutomation = getLastAutomation();
            templateClick = true;
            rootServiceInstance.handleTemplateClickEvents(message, Tabs.ASSIST, lastAutomation.dialogId, hostInstance);
        }
    }   

    // User messages handling...
    const handleUserMessageResponse = ((response: any) => {
        setShowErrorPrompt(response.isErrorPrompt);
        setAssistResponseArray((prevResponse: any) => {
            const assistResponse = [...prevResponse];
            let lastObj = assistResponse[assistResponse?.length - 1];
            if (lastObj && lastObj.type === RenderResponseType.SMALLTALK) {
                lastObj = rootServiceInstance.processUserMessagesForSmallTalk(response, lastObj, templateClick, hostInstance);
            } else if (lastObj?.type === RenderResponseType.AUTOMATION) {
                lastObj = rootServiceInstance.processUserMessagesForAutomation(response, lastObj, templateClick, hostInstance);
            }
            templateClick = false;
            return assistResponse;
        });
    })

    const showConversationSummaryResponse = (summaryObj: any) => {
        hideEmptyScreen();
        const summaryBannerAssist = getHTML(SummaryBannerHTMLEle, summaryObj, hostInstance);
        const summaryOverlayEle = document.querySelector(`${classConstants.ASSIST_SECTION}`);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, summaryBannerAssist, {
            event: SDK_EVENTS.SUMMARY_TEMPLATE_ASSIST,
            data : summaryObj
        });
        if(!summaryOverlayEle?.contains(summaryOverlayEle?.querySelector(`${classConstants.SUMMARY_CONVERSATION_SUMMARY}`))){
            summaryOverlayEle?.append(summaryBannerAssist);
        }
        hostInstance.eventManager?.addEventListener('.aa-copy-summary-text', 'click', () => {
            copySummaryText(summaryObj);
        }, summaryBannerAssist);
        let conversationSummaryEle = hostInstance?.chatEle?.querySelector(`${classConstants.SUMMARY_CONVERSATION_SUMMARY}`);
        if(conversationSummaryEle && summaryObj){
            conversationSummaryEle.innerText = summaryObj;
        }else{
            const summaryBannerAssist = getHTML(SummaryBannerHTMLEle, summaryObj, hostInstance);
            const summaryOverlayEle = document.querySelector(`${classConstants.ASSIST_SECTION}`);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, summaryBannerAssist, {
                event: SDK_EVENTS.SUMMARY_TEMPLATE_ASSIST,
                data : summaryObj
            });
            summaryOverlayEle?.append(summaryBannerAssist);
            hostInstance.eventManager?.addEventListener('.aa-copy-summary-text', 'click', () => {
                copySummaryText(summaryObj);
            }, summaryBannerAssist);
        }
    }

    const copySummaryText = (summaryText: any) => {
        navigator.clipboard.writeText(summaryText);
    }

    const formatListViewEntityList = () => {
        let entityList : any = [];
        let automation = getLastAutomation();        
        if(automation.type === RenderResponseType.AUTOMATION){
            let automationNodes = automation.automationNodes;
            automationNodes.forEach((node : any) => {
                if(node.nodeType === RenderResponseType.ENTITY_NODE){
                    entityList.push(node);
                }
            });
            cloneExistingAutomationToListView(entityList);
        }
    }

    const cloneExistingAutomationToListView = (entityList : any) => {
        entityList.forEach((entity : any) => {
            let entityNode = hostInstance?.chatEle?.querySelector(`${classConstants.ASK_CUST_NODE}${entity.uuid}`);
            let clonedNode = entityNode.cloneNode(true);
            clonedNode.querySelector(`${classConstants.ENTITY_HEADER}`)?.remove();
            rootServiceInstance.handleEntityNodeClickEvents(clonedNode, entity,ProjConstants.ASSIST, hostInstance);
            let listViewWrapper : any = hostInstance?.chatEle?.querySelector(`${classConstants.LIST_VIEW_BODY}`);
            listViewWrapper?.append(clonedNode);
        });
    }

    const renderEntityInListView = (entity: any, automation : any) => {
        if(entity?.type === RenderResponseType.AUTOMATION_NODE && entity?.nodeType === RenderResponseType.ENTITY_NODE){
            let manualMode = rootServiceInstance.manualAssistOverrideMode || !rootServiceInstance.proactiveMode;                
            let payload : any = { entityNode: entity, activeTab : ProjConstants.ASSIST, manualMode, view : 'listView' } 
            let template : any = '';
            if(entity.data.entityType != 'attachment'){
                template = getHTML(AskCustomer, payload, hostInstance);
            }else{
                entity.fileObj = {};
                template = getHTML(AttachmentAskCustomer, payload, hostInstance);
            }
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                event: SDK_EVENTS.ASK_CUSTOMER_TEMPLATE,
                data: payload
            });        
            rootServiceInstance.handleEntityNodeClickEvents(template, entity,ProjConstants.ASSIST, hostInstance);
            let listViewWrapper : any = hostInstance?.chatEle?.querySelector(`${classConstants.LIST_VIEW_BODY}`);
            listViewWrapper?.append(template);
            showLastNodeActionButtons(automation);
        }
    }

    const fetchAssistData = async () => {
        try {
            const params = {
                botId: hostInstance.rootService.connectionDetails.botId,
                conversationId: hostInstance.rootService.connectionDetails.conversationId,
                agentassisturl: hostInstance.rootService.connectionDetails.agentassisturl
            };

            let promiseArray =  [
                rootServiceInstance.getAssistFeedback(params, hostInstance).catch((error : any) => {
                    hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_FEEDBACK_API_FAILURE']);
                    return { results: [] };
                }),
                rootServiceInstance.getAssistHistory(params, hostInstance).catch((error : any) => {
                    hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_ASST_HISTORY_API_FAILURE']);
                    return { results: [] };
                })
            ]    

            if(rootServiceInstance?.customTabPrefsObj?.customTabEnabled){
                promiseArray.push(rootServiceInstance.getCustomTabFeedback(params, hostInstance).catch((error : any) => {
                    hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_FEEDBACK_API_FAILURE']);
                    return { results: [] };
                }));
            }

            // Fetch both history and feedback concurrently
            const [feedbackResponse, historyResponse, customTabFeedbackResponse] = await Promise.all(promiseArray);

            const feedbackData = feedbackResponse?.results || [];
            // const historyData = historyResponse?.results || [];
            let historyData = historyResponse?.results?.filter((ele : any) => !ele?.agentAssistDetails?.crId) || [];
            const customHistoryData = historyResponse?.results?.filter((ele :any)=> ele?.agentAssistDetails?.crId);
            if(rootServiceInstance?.customTabPrefsObj?.customTabEnabled){
                hostInstance.emit(INTERNAL_EVENTS.CUSTOM_TAB_HISTORY, customHistoryData, customTabFeedbackResponse?.results || []);
                rootServiceInstance.customTabHistoryData = customHistoryData;
            }

            if(historyData.length>0){
                hostInstance.rootService.isHistory = true
            }
            else{
                hostInstance.rootService.isHistory= false
            }
            if(!hostInstance?.rootService?.isAgenticCoPilotEnabled){
                renderHistoryMessages(historyData, feedbackData);
            }

        } catch (error) {
            console.error('Error fetching assist data:', error);
        } finally {
            hostInstance?.webSocketService?.emitTransferEvent();
        }
    };

    const generateInterimSummary = () => {        

                try {
                    if(rootServiceInstance.isSummaryMinimized){
                      rootServiceInstance.isSummaryMinimized = false;
                      hostInstance.emit(INTERNAL_EVENTS.IS_SUMMARY_MINIMIZED, false);
                      (hostInstance.chatEle.getElementById('SUMMARY_WRAPPER') as HTMLElement).style.setProperty('display', 'block', 'important');
                    }else{
                      if(!rootServiceInstance.isSummariesGenerated){
                        rootServiceInstance.fetchSummaries(hostInstance);
                      }else{
                        hostInstance.emit(INTERNAL_EVENTS.GENERATE_INTERIM_SUMMARY, true);
                      }
                    }
                } catch (error) {
                    console.error("Error generating interim summary:", error);
                }
            }

    const renderHistoryMessages = (historyData: any[], feedbackData: any[]) => {
        historyData.forEach((res: any) => {

            if(res.type === "outgoing"){

                let formattedHistoryItem = rootServiceInstance.formatHistoryResponseToNormalRender(res, feedbackData);

                if(!rootServiceInstance?.isAutomationOnGoing && formattedHistoryItem.eventType === "action" && formattedHistoryItem.dialogStart === true &&
                    formattedHistoryItem.intentName && formattedHistoryItem.positionId){
                        const dialog = rootServiceInstance.prepareDialogObjForAssistHistory(formattedHistoryItem);
                        rootServiceInstance.updateLocalStorageForAssist(hostInstance, dialog, true);
                        addAutomationNodeInAssistResponse(dialog);
                }
                
                if(rootServiceInstance?.isAutomationOnGoing && formattedHistoryItem.eventType === "action" && formattedHistoryItem.endOfTask === true){
                    let feedbackObj = feedbackData.find((feedback : any) => feedback.positionId === rootServiceInstance.currentAutomationId);
                    dialogTerminatedOrInterrupted(feedbackObj); 
                    currentEntityNode = null;
                }
                
                rootServiceInstance.handleHistoryPreviousAutomationNode(currentEntityNode, formattedHistoryItem, hostInstance);
                const responseType = rootServiceInstance.getTypeOfResponse(formattedHistoryItem);
                formatResponseBasedOnType(formattedHistoryItem, responseType);                
            }
            
        });
        hostInstance.rootService.isHistory = false

    };

    return (

        <Fragment>
            <div className="assist-data-wrapper-container">
                <div className="assist-block-content ast-block-content">
                    <ActiveOrPassive hostIns={hostInstance}>
                        <div className="assist-header-content aa-assist-header-section a-position-relative">
                        </div>
                    </ActiveOrPassive>
                    {/* <div className={`scroll-to-bottom-wrappers aa-assist-scroll-wrapper`}>
                        
                    </div> */}
                    {/* needs to be added in mybot */}
                    <ActiveOrPassive hostIns={hostInstance}>
                    <div className="scroll-data-assist aa-assist-section chat-widget-body-wrapper" id="assist-section"> 
                       {/* all types of responses(suggestions, automation, smalltalk) */}
                    </div>
                    </ActiveOrPassive>
                    <div className="agentic-copilot-mode-wrapper a-flex a-justify-content-center a-align-items-center aa-desc-xs a-padding-smm aa-hidden">
                        {hostInstance?.languagedata?.AGENTIC_COPILOT_MODE_TITLE}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
